import type { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import type { Dispatch } from 'redux';

import { NotificationServiceType } from '@swf/core/enums';
import { select } from '@swf/core/store';
import { useUserNotificationSubscription } from '@swf/generated/graphql/notifications/hooks';
import type { Notification } from '@swf/generated/graphql/notifications/schemas';

const parseNotification = (notification: Notification, dispatch: Dispatch) => {
  try {
    const payload = JSON.parse(decodeURI(notification.payload));
    switch (notification.type) {
      case NotificationServiceType.SpendBudget:
        if (payload?.limitValue) {
          dispatch.modal.enqueue({
            path: '/notifications/spend-budget',
            locationState: { limit: payload.limitValue }
          });
        }
    }
  } catch {
    // proceed to next message in case message is faulty
  }
};

const useNotificationSubscription = (client: ApolloClient<NormalizedCacheObject>) => {
  const dispatch = useDispatch();
  const { idpToken = '' } = useSelector(select.session.get);
  useUserNotificationSubscription({
    shouldResubscribe: () => !idpToken,
    fetchPolicy: 'no-cache',
    onData: (res) => {
      const data = res.data.data?.subscribe;
      if (data) {
        if ('payload' in data) {
          parseNotification(data, dispatch);
        } else {
          data.notifications?.forEach((n) => {
            if (n) parseNotification(n, dispatch);
          });
        }
      }
    },
    client
  });
};

export default useNotificationSubscription;
